var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useListItem } from '@floating-ui/react';
import { Button } from '../button';
import { useDropdown } from '../dropdown/dropdown-context';
import { buttonStaticStyle } from './styles';
function MenuButton(_a) {
    var { onClick } = _a, restProps = __rest(_a, ["onClick"]);
    const { getItemProps, setIsOpen, size, triggerRef } = useDropdown();
    const { ref } = useListItem();
    function handleClick(event) {
        var _a;
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        setIsOpen(false);
        // @ts-expect-error: focus() not recognized
        (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    return (
    // @ts-expect-error: spread props out of sync
    _jsx(Button, Object.assign({}, getItemProps(Object.assign({ onClick: handleClick }, restProps)), { ref: ref, role: "menuitem", tabIndex: -1 }, { size }, { css: buttonStaticStyle })));
}
export default MenuButton;
